import { render } from "./ListDestinataire.vue?vue&type=template&id=1aff5764&scoped=true"
import script from "./ListDestinataire.vue?vue&type=script&lang=js"
export * from "./ListDestinataire.vue?vue&type=script&lang=js"

import "./ListDestinataire.vue?vue&type=style&index=0&id=1aff5764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aff5764"]])

export default __exports__